import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const Subtitle = styled.div`
    display: ${({ display }) => display && display};
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    text-align: ${({ textAlign }) => (textAlign ? textAlign : '')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    width: ${({ width }) => (width ? width : '100%')};
    ${media.mobileDevice`
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '90%')};
          margin-bottom: ${({ marginBottom }) =>
              marginBottom ? marginBottom : '0px'};
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: ${({ color }) => (color ? color : '#1010EB')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    display: ${({ display }) => (display ? display : '')};
    cursor: ${({ cursor }) => (cursor ? cursor : '')};
    ${media.mobileDevice`
    `}
`;
export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};

    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const DisplayCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    padding: 15px 16px;
    margin-bottom: 10px;
    ${media.mobileDevice`
    border: 1px solid #74DED6;
    margin-bottom: 10px;
    `}
`;
export const ContainerItems = styled.div`
    width: 47%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    justify-content: space-between;
    ${media.mobileDevice`
        width: 88%;   
    `}
`;

export const Value = styled.div`
    display: flex;
    justify-content: flex-end;
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: 16px;
    width: 90%;
    ${media.mobileDevice`
    justify-content:flex-start;
    `}
`;

export const Header = styled.div`
    font-family: AvenirNextWorld Demi;
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: 13px;
    margin-bottom: 0px;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
